import React, { useState, useEffect } from "react";
import "./style.css";
import devMetaInfo from '../../config/buildFile.json';
import qaMetaInfo from '../../config/buildFileqa.json';
import prodMetaInfo from '../../config/buildFilepro.json';
import { isLocalDevEnv } from "../../config/service-api-mapping";
import { env } from "../../common/constants";
import _ from "lodash";


const Footer = () => {
  const [envName, setEnvName] = useState("");
  const [versionInfo, setVersionInfo] = useState<any>();
  const [isSmallerDeviceRes, setIsSmallerDeviceRes] = useState<boolean>(
    window?.innerWidth <= 992
  );
  const getFooter = () => {
    const host = window.location.hostname;
    if (_.isEqual(host, "sltrader.matrixapps.com") || _.isEqual(host, "10.254.122.30")) {
      return { env: env.Prod, metaInfo: prodMetaInfo };
    }
    else if (_.isEqual(host, "sltrader-dev.matrixapps.com") || _.isEqual(host, "10.254.131.231")) {
      return { env: env.Dev, metaInfo: devMetaInfo };
    }
    else if (_.isEqual(host, "sltrader-qa.matrixapps.com") || _.isEqual(host, "10.254.102.244")) {
      return { env: env.QA, metaInfo: qaMetaInfo };
    }
    else if (host?.includes('localhost')) {
      return isLocalDevEnv ? { env: env.Dev, metaInfo: devMetaInfo } : { env: env.QA, metaInfo: qaMetaInfo };
    }

    return { env: env.Dev, metaInfo: devMetaInfo };
  }

  useEffect(() => {
    const { env, metaInfo } = getFooter()
    setEnvName(env)
    setVersionInfo(metaInfo)
  }, []);

  useEffect(() => {
    // Function to handle the resize event
    function handleResize() {
      setIsSmallerDeviceRes(window.innerWidth <= 992);
    }

    // Add the event listener
    window.addEventListener("resize", handleResize);

    // Cleanup the event listener on component unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (

    <div className={`${isSmallerDeviceRes?'stagingDiv-small row':'stagingDiv'}`}>
      <div className={`${isSmallerDeviceRes?'stagingBtn-small col':'stagingBtn'}`}>
        {envName} -
        &nbsp;
        {`Version ${versionInfo?.buildMajor}.${versionInfo?.buildMinor}.${versionInfo?.buildRevision}`}
      </div>

      <div>

      </div>
      <div className={`copyRight-footer ${isSmallerDeviceRes?'col text-nowrap justify-content-center align-content-center align-items-center':''}`}>
        Copyright <span className="copy">&nbsp;&copy;&nbsp;</span> South Street
        Securities Inc 2025
      </div>
      <div></div>
    </div>
  );
};

export default Footer;
